/* eslint @typescript-eslint/no-var-requires: "off" */
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { registerLocale } from 'i18n-iso-countries';

// Read files in locals folder
// @ts-ignore
const transFiles = require.context('services/locales', true, /\.ts$/);
const resources = {};

// Generate
// @ts-ignore
transFiles.keys().forEach((fileWithPath) => {
  const pathArray = fileWithPath.split('/');
  const locale = pathArray[1] || 'en';
  const fileName = pathArray[2] ? pathArray[2].replace('.ts', '') : 'unknown';

  if (!(locale in resources)) {
    // @ts-ignore
    resources[locale] = {};
  }

  // @ts-ignore
  resources[locale][fileName] = transFiles(fileWithPath).default;
});

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

// initialize the ISO-Countries translations for the current language
const { language } = i18next;
// eslint-disable-next-line import/no-dynamic-require
registerLocale(require(`i18n-iso-countries/langs/${language}.json`));
